var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paddingBox" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rounded-box --whiteBg p-50" },
      [
        _c("validation-observer", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var handleSubmit = ref.handleSubmit
                var errors = ref.errors
                return [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return handleSubmit(_vm.submitKolektiv)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-12" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Názov kolektívu" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "label",
                                          { attrs: { for: "nazov-kolektivu" } },
                                          [_vm._v("Názov kolektívu")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.pouzivatel_name,
                                              expression: "form.pouzivatel_name"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-error": errors.length },
                                          attrs: {
                                            type: "text",
                                            name: "nazov-kolektivu",
                                            id: "nazov-kolektivu",
                                            required: ""
                                          },
                                          domProps: {
                                            value: _vm.form.pouzivatel_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.form,
                                                "pouzivatel_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Kontaktný e-mail" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "label",
                                          { attrs: { for: "kontaktny-email" } },
                                          [_vm._v("Kontaktný e-mail")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.pouzivatel_email,
                                              expression:
                                                "form.pouzivatel_email"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-error": errors.length },
                                          attrs: {
                                            type: "email",
                                            name: "kontaktny-email",
                                            id: "kontaktny-email",
                                            required: ""
                                          },
                                          domProps: {
                                            value: _vm.form.pouzivatel_email
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.form,
                                                "pouzivatel_email",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Heslo" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "label",
                                          { attrs: { for: "heslo" } },
                                          [_vm._v("Vytvorte si heslo")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.form.pouzivatel_password,
                                              expression:
                                                "form.pouzivatel_password"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-error": errors.length },
                                          attrs: {
                                            type: "password",
                                            name: "heslo",
                                            id: "heslo",
                                            required: ""
                                          },
                                          domProps: {
                                            value: _vm.form.pouzivatel_password
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.form,
                                                "pouzivatel_password",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-start" },
                            [
                              _c("label", { staticClass: "w-auto mr-3 mb-0" }, [
                                _vm._v("Typ kolektívu")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.typ_kolektivu,
                                        expression: "typ_kolektivu"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "customRadioInline1",
                                      name: "customRadioInline",
                                      value: "zs"
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.typ_kolektivu, "zs")
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.typ_kolektivu = "zs"
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "customRadioInline1" }
                                    },
                                    [_vm._v("Škola")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.typ_kolektivu,
                                        expression: "typ_kolektivu"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "customRadioInline2",
                                      name: "customRadioInline",
                                      value: "ms"
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.typ_kolektivu, "ms")
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.typ_kolektivu = "ms"
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "customRadioInline2" }
                                    },
                                    [_vm._v("Škôlka")]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-9" },
                          [
                            _vm.typ_kolektivu === "zs"
                              ? [
                                  _c("validation-provider", {
                                    key: "skola",
                                    attrs: { rules: "required", name: "Škola" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "skola" } },
                                                [_vm._v("Škola")]
                                              ),
                                              _vm._v(" "),
                                              _c("v-select", {
                                                class: {
                                                  "is-error": errors.length
                                                },
                                                attrs: {
                                                  filter: _vm.filterSkoly,
                                                  id: "skola",
                                                  label: "cely_nazov",
                                                  options: _vm.skoly,
                                                  clearable: false,
                                                  placeholder:
                                                    "Začnite písať pre vyhľadanie školy zo zoznamu"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "no-options",
                                                      fn: function(ref) {
                                                        var search = ref.search
                                                        var searching =
                                                          ref.searching
                                                        return [
                                                          searching
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                            Nenašla sa žiadna škola "
                                                                ),
                                                                _c("em", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      search
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(
                                                                  ".\n                                        "
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.form.pouzivatel_skola,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pouzivatel_skola",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.pouzivatel_skola"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typ_kolektivu === "ms"
                              ? [
                                  _c("validation-provider", {
                                    key: "skolka",
                                    attrs: {
                                      rules: "required",
                                      name: "Škôlka"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "skolka" } },
                                                [_vm._v("Škôlka")]
                                              ),
                                              _vm._v(" "),
                                              _c("v-select", {
                                                class: {
                                                  "is-error": errors.length
                                                },
                                                attrs: {
                                                  filter: _vm.filterSkoly,
                                                  id: "skolka",
                                                  label: "cely_nazov",
                                                  options: _vm.skolky,
                                                  clearable: false,
                                                  placeholder:
                                                    "Začnite písať pre vyhľadanie škôlky zo zoznamu"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "no-options",
                                                      fn: function(ref) {
                                                        var search = ref.search
                                                        var searching =
                                                          ref.searching
                                                        return [
                                                          searching
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                            Nenašla sa žiadna škôlka "
                                                                ),
                                                                _c("em", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      search
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(
                                                                  ".\n                                        "
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.form.pouzivatel_skola,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pouzivatel_skola",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.pouzivatel_skola"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.typ_kolektivu === "zs"
                          ? _c("div", { staticClass: "col-12 col-md-3" }, [
                              _c("label", { attrs: { for: "rocnik" } }, [
                                _vm._v("Ročník")
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.pouzivatel_rocnik,
                                      expression: "form.pouzivatel_rocnik"
                                    }
                                  ],
                                  staticClass: "custom-select",
                                  attrs: { name: "rocnik", id: "rocnik" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form,
                                        "pouzivatel_rocnik",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: 1 } }, [
                                    _vm._v("1. ročník")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 2 } }, [
                                    _vm._v("2. ročník")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 3 } }, [
                                    _vm._v("3. ročník")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 4 } }, [
                                    _vm._v("4. ročník")
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "separator" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row mb-0" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-12 text-right" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn --primary",
                                attrs: { type: "submit" }
                              },
                              [_vm._v("pokračovať na ďalší krok")]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex align-items-center justify-content-between mb-20"
      },
      [
        _c("h2", { staticClass: "mb-0" }, [_vm._v("Registrácia kolektívu")]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-0" }, [
          _vm._v("Prosíme, vyplňte všetky polia.")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }